import React, { useState } from 'react'
import { FaBars } from 'react-icons/fa'
import { IoClose } from 'react-icons/io5'
import { Link } from 'react-router-dom'
import { Link as ScrollLink } from 'react-scroll'

function Header() {

    const [bars, setBars] = useState(false)

    return (
        <header>


            <div className="header1">
                <div className='headerLogo'>
                    <ScrollLink to='skizb' smooth={true} duration={500} offset={-80}><Link className='Link' to={'/'}><h1>Auto</h1><h2>Arm</h2></Link></ScrollLink>

                    <div className={bars === false ? 'navigacia' : 'nerqevNavigacia'}>
                        <li ><ScrollLink onClick={() => { setBars(false) }} to="catalog" smooth={true} duration={500} offset={-80}><Link className='Link' to={'/'}    >Կատալոգ</Link></ScrollLink></li>
                        <li ><ScrollLink onClick={() => { setBars(false) }} to="about" smooth={true} duration={500} offset={-80}><Link className='Link' to={'/'} >Մեր մասին</Link></ScrollLink></li>
                        <li ><ScrollLink onClick={() => { setBars(false) }} to="contact" smooth={true} duration={500} offset={-80}><Link className='Link' to={'/'}>Կապ</Link></ScrollLink></li>

                    </div>


                </div>
                <div>
                    <button onClick={() => { setBars(!bars) }} className={bars === false ? "btnBars" : 'btnClose'}><FaBars color='black' size={"20px"} /></button>
                    <button onClick={() => { setBars(!bars) }} className={bars === false ? "btnClose" : 'btnBars'}><IoClose color='black' size={"20px"} /></button>
                </div>



            </div>
            <hr />
            <div className='header2' >



                <div className='headerNumberOnly'>

                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg><p className='hamar'>+374 94 474816</p>

                </div>
                <div>
                    <button><a href="tel:+37494474816">Զանգահարել</a></button>
                </div>

            </div>


        </header >
    )
}

export default Header
